export default "__VITE_ASSET__fS_adleQ__"